import { get, post } from '../../utils/http';

const agentEnginePath = (accountId, suffix = '') => `/accounts/${accountId}/agent-engine${suffix}`;

export const fetchAgentAssignments = ({ accountId, agentSlug, subjectId, includeOff }) =>
  get(agentEnginePath(accountId, '/assignments'), {
    agent_slug: agentSlug,
    subject_id: subjectId,
    include_off: includeOff
  });

// branch_id is required: without one the assignment reads /branches/0/... and 403s for life.
export const activateAgentAssignment = ({ accountId, agentSlug, subjectId, branchId, subjectType = 'project' }) =>
  post(agentEnginePath(accountId, '/assignments'), {
    agent_slug: agentSlug,
    subject_id: subjectId,
    subject_type: subjectType,
    branch_id: branchId
  });

export const deactivateAgentAssignment = ({ accountId, agentSlug, subjectId, subjectType = 'project' }) =>
  post(agentEnginePath(accountId, '/assignments/off'), {
    agent_slug: agentSlug,
    subject_id: subjectId,
    subject_type: subjectType
  });

// Per event: without subject_id the read answers with a new event's mode, the write 422s.
export const fetchAgentAutonomy = ({ accountId, agentSlug, subjectId, subjectType = 'project' }) =>
  get(agentEnginePath(accountId, '/autonomy'), {
    agent_slug: agentSlug,
    subject_id: subjectId,
    subject_type: subjectType
  });

export const setAgentAutonomyMode = ({ accountId, agentSlug, mode, subjectId, subjectType = 'project' }) =>
  post(agentEnginePath(accountId, '/autonomy/mode'), {
    agent_slug: agentSlug,
    mode,
    subject_id: subjectId,
    subject_type: subjectType
  });

export const fetchAgentApprovals = ({ accountId, projectId }) =>
  get(agentEnginePath(accountId, '/approvals'), { project_id: projectId });

export const resolveAgentApproval = ({ accountId, confirmationId, action }) =>
  post(agentEnginePath(accountId, `/approvals/${confirmationId}`), { action });

export const fetchAgentRuns = ({ accountId, agentSlug, subjectId, limit = 1 }) =>
  get(agentEnginePath(accountId, '/runs'), { agent_slug: agentSlug, subject_id: subjectId, limit });

// Reads the booker's own table only, so it's safe to poll — unlike /board, which hits giovanni.
export const fetchAgentStats = ({ accountId, projectId }) =>
  get(agentEnginePath(accountId, `/projects/${projectId}/stats`));
